import * as React from 'react';
import { SelectOption } from 'formComponents/Select/types';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import { textbausteineSelector } from 'store/lookups/selector';
import { callApi, Controller } from './useApi';

export interface Textbaustein {
    kz: number;
    nr: number;
    name: string;
    kurz: string;
    lang: string;
}

export const defaultTextbaustein: Textbaustein = {
    kz: 0,
    nr: 0,
    name: '',
    kurz: '',
    lang: '',
};

export function useTextbausteineAsOptions(): SelectOption[] {
    const textbausteine = useSelector(textbausteineSelector);

    return React.useMemo<SelectOption[]>(() => {
        return textbausteine.map(
            (textbaustein) => ({ value: textbaustein.nr.toString(), label: textbaustein.name } as SelectOption),
        );
    }, [textbausteine]);
}

export async function addTextbaustein(textbaustein: Textbaustein): Promise<void> {
    return callApi<void>(Controller.textbaustein + '/add', { textbaustein });
}

export async function updateTextbaustein(textbaustein: Textbaustein): Promise<void> {
    return callApi<void>(Controller.textbaustein + '/update', { textbaustein });
}

export async function deleteTextbaustein(textbaustein: Textbaustein): Promise<void> {
    return callApi<void>(Controller.textbaustein + '/update', { textbaustein });
}
